import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

export function galleryQrUrl(value) {
  if (typeof value !== 'string' || value !== value.trim()) return null;
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'https:' && !parsed.username && !parsed.password ? value : null;
  } catch (_) { return null; }
}

// Encode the Gallery's existing selected image URL; no download API or URL rewriting.
export default function GalleryDownloadQr({ url }) {
  const [result, setResult] = useState(null);
  useEffect(() => {
    let cancelled = false;
    setResult(null);
    const value = galleryQrUrl(url);
    if (value) {
      QRCode.toDataURL(value, { width: 220, margin: 4, errorCorrectionLevel: 'M', color: { dark: '#000000', light: '#ffffff' } })
        .then(image => { if (!cancelled) setResult({ url, image }); })
        .catch(() => { if (!cancelled) setResult(null); });
    }
    return () => { cancelled = true; };
  }, [url]);
  return result && result.url === url ? <div className="gallery-download-qr"><img src={result.image} alt="Scan to download this photo" width="220" height="220" /><span>Scan to download photo</span></div> : null;
}
